const userStarsCash = resolve => require(["@/pages/cash/userStarsCash/index.vue"], resolve);
const starsCash = resolve => require(["@/pages/cash/starsCash/index.vue"], resolve);
export default [
  /****************会员管理***************/
  {
    path: "/cash/starsCash",
    name: "提现管理",
    component: starsCash,
  },
  {
    path: "/cash/userStarsCash",
    name: "提现管理",
    component: userStarsCash,
  }
];
